<template>
    <v-app id="profile">
        <v-app-bar height="80" app>
            <router-link :to="{name: 'main'}">
                <v-img alt="Logo" contain src="@/assets/ravenpod-text.png" transition="scale-transition" width="150"/>          
            </router-link>
            <v-spacer></v-spacer>
            <v-btn text @click.prevent="$router.push({name: 'profile'})">
                <v-avatar class="mr-2" size="32">
                    <amplify-s3-image class="avatar-small"
                        :key="currentUserProfilePictureURL() ? currentUserProfilePictureURL() : 'default-user-profile-picture.png'"
                        :img-key="currentUserProfilePictureURL() ? currentUserProfilePictureURL() : 'default-user-profile-picture.png'" />
                </v-avatar>
                {{ currentUserName() }}
            </v-btn>
            <v-btn @click.prevent="logout" text><v-icon class="mr-1">mdi-logout</v-icon>Logout</v-btn>                          
        </v-app-bar>
        <v-main>        
            <v-container>

                <v-dialog persistent v-model="showDialog" width="500">
                    <v-card>
                        <v-card-title>Check Your Email</v-card-title>
                        <v-card-subtitle class="mt-2">Enter the verification code we sent to your email <b>{{ user.email }}</b></v-card-subtitle>
                        <v-fade-transition>
                            <v-alert v-show="incorrectVerificationCode" dense class="mx-6" max-width="500" type="error">Incorrect Verification Code</v-alert>
                        </v-fade-transition>
                        <v-card-text class="">
                            <v-form ref="verifyForm">
                                <v-text-field
                                    outlined
                                    v-model="verificationCode"
                                    label="Verification code"
                                    :rules="[rules.required]"
                                ></v-text-field>
                            </v-form>
                        </v-card-text>
                        <v-card-actions class="pa-4">
                            <v-spacer></v-spacer>
                            <v-btn :disabled="loading" :loading="loading" @click="handleVerifyEmail" color="primary">verify</v-btn>
                        </v-card-actions>
                    </v-card>
                </v-dialog>

                <v-fade-transition>
                    <v-alert v-show="alertMessage" class="mt-10 mx-auto" max-width="960" :type="alertType">{{ alertMessage }}</v-alert>
                </v-fade-transition>

                <v-card class="mt-10 mx-auto" max-width="960">
                    <v-card-title>Account Profile</v-card-title>
                    <v-tabs vertical>
                        <v-tab>
                            <v-icon left>mdi-account</v-icon>
                            General
                        </v-tab>
                        <v-tab>
                            <v-icon left>mdi-lock</v-icon>
                            Password
                        </v-tab>
                        <v-tab-item>
                            <v-card class="pa-5 mx-auto" max-width="640" flat>
                                <v-card-text>
                                    <v-form ref="generalForm">
                                        <v-row>
                                            <v-col class="text-center">                                                
                                                <v-avatar size="196">
                                                    <amplify-s3-image class="avatar-large"
                                                        :key="currentUserProfilePictureURL() ? currentUserProfilePictureURL() : 'default-user-profile-picture.png'"
                                                        :img-key="currentUserProfilePictureURL() ? currentUserProfilePictureURL() : 'default-user-profile-picture.png'" />
                                                </v-avatar>
                                                <br/>
                                                <input ref="fileInput" type="file" accept="image/png, image/jpeg" @change="onFileSelected" style="display: none">                                                
                                                <v-btn :disabled="loading" :loading="loading" @click="$refs.fileInput.click();" class="mt-3" text color="primary">change profile picture</v-btn>
                                            </v-col>
                                        </v-row>
                                        <v-text-field
                                            v-model="user.name"
                                            label="Name"
                                            :rules="[rules.required]"
                                        ></v-text-field>

                                        <v-text-field
                                            v-model="user['custom:company_name']"
                                            label="Company name"
                                        ></v-text-field>

                                        <v-text-field
                                            v-model="user.email"
                                            label="Email address"
                                            :rules="[rules.required, rules.email]"
                                        ></v-text-field>

                                        <v-text-field
                                            v-model="user.phone_number"
                                            label="Mobile"
                                            :rules="[rules.required]"
                                        ></v-text-field>

                                    </v-form>
                                </v-card-text>
                                
                                <v-card-actions>
                                    <v-btn color="primary" :disabled="loading" :loading="loading" @click="handleUpdateUserAttributes">update</v-btn>
                                </v-card-actions>

                            </v-card>
                        </v-tab-item>
                        <v-tab-item>
                            <v-card class="pa-5 mx-auto" max-width="640" flat>
                                <v-card-text>
                                    <v-form ref="passwordForm">
                                        <v-text-field
                                            type="password"
                                            v-model="oldPassword"
                                            label="Current password"
                                            :rules="[rules.required]"
                                        ></v-text-field>

                                        <v-text-field
                                            type="password"
                                            v-model="newPassword"
                                            label="New password"
                                            :rules="[rules.required, rules.min8Chars, rules.password]"
                                        ></v-text-field>

                                        <v-text-field
                                            type="password"
                                            v-model="confirmPassword"
                                            label="Confirm new password"
                                            :rules="[rules.required, passwordConfirmationRule]"
                                        ></v-text-field>

                                    </v-form>
                                </v-card-text>
                                
                                <v-card-actions>
                                    <v-btn color="primary" :disabled="loading" :loading="loading" @click="handleUpdatePassword">Update Password</v-btn>
                                </v-card-actions>
                            </v-card>
                        </v-tab-item>
                    </v-tabs>
                </v-card>


            </v-container>
        </v-main>
    </v-app>
</template>

<script>
import { Auth, Storage } from 'aws-amplify';
import FormHelper from '@/helpers/form_helper'

export default {
    name: 'Profile',
    data() {
        return {
            user: {
                name: this.currentUserName(),
                'custom:company_name': this.currentUserCompanyName(),
                email: this.currentUserEmail(),
                phone_number: this.currentUserPhoneNumber(),
            },
            oldPassword: null,
            newPassword: null,
            confirmPassword: null, 
            loading: false,
            alertMessage: null,           
            alertType: null,
            rules: FormHelper.rules,
            showDialog: false,
            verificationCode: null,
            incorrectVerificationCode: false,
            changePicture: false
        };
    },
    computed: {
        passwordConfirmationRule() {
            return () => (this.newPassword === this.confirmPassword) || 'Password must match'
        },
    },
    methods: {

        scheduleAlertDismissal: function() {
            setTimeout(()=>{this.alertMessage = null}, 8000)
        },

        onFileSelected: function(event) {
            this.loading = true
            let file = event.target.files[0]
            Storage.put(`${this.currentUserID()}/avatar/${file.name}`, file, {
                contentType: 'image/png'
            })
            .then (async (result) => {
                let currentUser = await Auth.currentAuthenticatedUser()
                Auth.updateUserAttributes(currentUser, {profile: result.key})  
                .then(async (data) => {
                    await this.$store.dispatch('auth/fetchUser')
                })
                .catch((err) => {
                    this.alertType = 'error'
                    this.alertMessage = `Profile update failed. ${err.message}`
                    this.scheduleAlertDismissal();
                })
                .finally(() => {
                    this.loading = false
                })
            })
            .catch((err) => {
                console.log(err)
                this.alertType = 'error'
                this.alertMessage = `Upload failed. ${err.message}`
                this.scheduleAlertDismissal();
            })
            .finally( () => {
                this.loading = false
            })
        },

        handleVerifyEmail: function() {
            if (!this.$refs.verifyForm.validate()) return;
            Auth.verifyCurrentUserAttributeSubmit('email', this.verificationCode)
            .then(async (data) => {
                this.incorrectVerificationCode = false
                this.showDialog = false
                this.alertType = 'success'
                this.alertMessage = "Profile updated successfully"
                this.scheduleAlertDismissal();
                await this.$store.dispatch('auth/fetchUser')
            })
            .catch((err) => {
                this.incorrectVerificationCode = true
            })
            .finally(() => {
                this.loading = false
            })   
        },

        handleUpdateUserAttributes: async function() {
            if (!this.$refs.generalForm.validate()) return;
            this.loading = true
            let currentUser = await Auth.currentAuthenticatedUser()
            Auth.updateUserAttributes(currentUser, this.user)  
            .then(async (data) => {
                if (this.currentUserEmail() != this.user.email) {
                    this.showDialog = true;
                } else {
                    this.alertType = 'success'
                    this.alertMessage = "Profile updated successfully"
                    this.scheduleAlertDismissal();
                    await this.$store.dispatch('auth/fetchUser')
                }
            })
            .catch((err) => {
                this.alertType = 'error'
                this.alertMessage = `Profile update failed. ${err.message}`
                this.scheduleAlertDismissal();
            })
            .finally(() => {
                this.loading = false
            })   
        },
        handleUpdatePassword: async function() {
            if (!this.$refs.passwordForm.validate()) return;
            this.loading = true
            let currentUser = await Auth.currentAuthenticatedUser()
            Auth.changePassword(currentUser, this.oldPassword, this.newPassword)
            .then((data) => {
                this.alertType = 'success'
                this.alertMessage = "Password updated successfully"
                this.scheduleAlertDismissal();
                this.$refs.passwordForm.reset();
            })
            .catch((err) => {
                this.alertType = 'error'
                this.alertMessage = `Passowrd update failed. ${err.message}`
                this.scheduleAlertDismissal();
            })
            .finally(() => {
                this.loading = false
            })   
        }
    },
    mounted() {
    }
};
</script>

<style scoped>
    amplify-s3-image.avatar-small {
        --height: 32px;
        --width: 32px;
    }

    amplify-s3-image.avatar-large {
        --height: 196px;
        --width: 196px;
    }
</style>